import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { capitalize } from 'lodash';
import moment from 'moment';

import { Paper } from '@material-ui/core';
import { LineGraph } from '../../components';

import {
  changeNumberOfUsersTimeFrame,
  changeNumberOfUsersType,
  changeNumberOfUsersStartDate,
  changeNumberOfUsersEndDate,
} from '../../actions';
import { loadTexts } from '../../../../config/texts';
import { getNumUsers } from '../../selectors';

const TEXT_KEY = 'dashboard';

class NumberOfUsersCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: '',
      endDate: '',
      texts: loadTexts(TEXT_KEY, props.locale),
    };

    this._timeFrames = [
      { value: 'day', label: this.state.texts.labels.day },
      { value: 'week', label: this.state.texts.labels.week },
      { value: 'month', label: this.state.texts.labels.month },
      { value: 'year', label: this.state.texts.labels.year },
    ];

    this._types = [
      { value: 'student', label: this.state.texts.labels.student },
      { value: 'tutor', label: this.state.texts.labels.tutor },
      { value: 'both', label: this.state.texts.labels.both },
    ];

    this._onTimeFrameChange = this._onTimeFrameChange.bind(this);
    this._onTypeChange = this._onTypeChange.bind(this);
    this._onChangeStartDate = this._onChangeStartDate.bind(this);
    this._onChangeEndDate = this._onChangeEndDate.bind(this);
    this._onClickUpdate = this._onClickUpdate.bind(this);
  }

  componentWillMount() {
    const today = moment();
    const start = today.clone().add(-1, 'month').format('Y-MM-DD');
    const end = today.format('Y-MM-DD');
    this.props.changeNumberOfUsersStartDate(start);
    this.props.changeNumberOfUsersEndDate(end);
    this.setState({ startDate: start, endDate: end });
  }

  _onTimeFrameChange(value) {
    this.props.changeNumberOfUsersTimeFrame(value);
  }

  _onTypeChange(value) {
    this.props.changeNumberOfUsersType(value);
  }

  _onChangeStartDate(value) {
    this.setState({ startDate: value });
  }

  _onChangeEndDate(value) {
    this.setState({ endDate: value });
  }

  _onClickUpdate() {
    const { startDate, endDate } = this.state;
    this.props.changeNumberOfUsersStartDate(startDate);
    this.props.changeNumberOfUsersEndDate(endDate);
  }

  render() {
    const { currentTimeFrame, currentType, lessonsData: { data, labels } } = this.props;
    const { startDate, endDate, texts } = this.state;

    return (
      <Paper>
        <LineGraph
          title={texts.title.number_users}
          data={data}
          labels={labels}
          label={capitalize(currentType)}
          onTimeFrameChange={this._onTimeFrameChange}
          onTypeChange={this._onTypeChange}
          timeFrames={this._timeFrames}
          types={this._types}
          currentTimeFrame={currentTimeFrame}
          currentType={currentType}
          startDate={startDate}
          endDate={endDate}
          onChangeStartDate={this._onChangeStartDate}
          onChangeEndDate={this._onChangeEndDate}
          onClickUpdate={this._onClickUpdate}
        />
      </Paper>
    );
  }
}

NumberOfUsersCard.propTypes = {
  changeNumberOfUsersTimeFrame: PropTypes.func.isRequired,
  changeNumberOfUsersType: PropTypes.func.isRequired,
  changeNumberOfUsersStartDate: PropTypes.func.isRequired,
  changeNumberOfUsersEndDate: PropTypes.func.isRequired,
  currentTimeFrame: PropTypes.string.isRequired,
  currentType: PropTypes.string.isRequired,
  lessonsData: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  currentTimeFrame: state.dashboard.graphs.numberOfUsersTimeFrame,
  currentType: state.dashboard.graphs.numberOfUsersType,
  lessonsData: getNumUsers(state),
  locale: state.appState.locale,
});

const mapDispatchToProps = dispatch => ({
  changeNumberOfUsersTimeFrame: params => dispatch(changeNumberOfUsersTimeFrame(params)),
  changeNumberOfUsersType: params => dispatch(changeNumberOfUsersType(params)),
  changeNumberOfUsersStartDate: params => dispatch(changeNumberOfUsersStartDate(params)),
  changeNumberOfUsersEndDate: params => dispatch(changeNumberOfUsersEndDate(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NumberOfUsersCard);



// WEBPACK FOOTER //
// ./src/modules/dashboard/cards/NumberOfUsersCard/index.js